import { useTranslation } from 'react-i18next';
import { cx } from '@platform/core/lib/cx';
import type { CustomizationScope } from './CustomizationScope';
import type { IScopeSwitchProps } from './IScopeSwitchProps';

/**
 * Перемикач рівня налаштування «Робочий простір / Глобально» (прототип v4 G:L748–752, SP-01): radiogroup «Рівень налаштування», варіанти
 * 28px 12px 600; активний — --surface з тінню; недоступний — вимкнений, у підказці — чому (потрібна роль у просторі чи глобальна роль).
 */
export function ScopeSwitch({ state, workspaceName }: IScopeSwitchProps) {
  const { t } = useTranslation();
  const options: Array<{ key: CustomizationScope; label: string; ok: boolean; title: string; why: string }> = [
    { key: 'ws', label: t('sysPages.scope.ws'), ok: state.canWs, title: workspaceName, why: t('sysPages.scope.wsWhy') },
    { key: 'global', label: t('sysPages.scope.global'), ok: state.canGlobal, title: t('sysPages.scope.globalTitle'), why: t('sysPages.scope.globalWhy') },
  ];
  return (
    <div className="sm-scope" role="radiogroup" aria-label={t('sysPages.scope.label')}>
      {options.map((o) => (
        <button key={o.key} type="button" role="radio" aria-checked={state.scope === o.key} disabled={!o.ok} title={o.ok ? o.title : o.why}
          className={cx('sm-scope__opt', state.scope === o.key && 'is-on')} onClick={() => state.setScope(o.key)}>
          {o.label}
        </button>
      ))}
    </div>
  );
}
